<div class="load">
    <div style="flex-wrap: wrap;">
      <h2>{{errorData.message}}</h2> 
      <button type="button" class="btn btn-info"
      (click)="close()">Continuar</button>
    </div>
</div>

